import axios from 'axios';
import { parsePhoneNumberFromString as parsePhoneNumber } from 'libphonenumber-js';
export default class OnlinePBXService {
    apiKey;
    axios;
    authorizePromise;
    static instance;
    static getInstance(domain, apiKey) {
        if (!this.instance)
            this.instance = new OnlinePBXService(domain, apiKey);
        return this.instance;
    }
    constructor(domain, apiKey) {
        this.apiKey = apiKey;
        this.axios = axios.create({
            baseURL: `https://api2.onlinepbx.ru/${domain}/`,
        });
        this.axios.interceptors.request.use((config) => {
            if (!config.headers)
                config.headers = {};
            config.headers['Content-type'] = 'application/x-www-form-urlencoded';
            const { key, key_id } = this.getCredentials();
            if (!key)
                return config;
            config.headers['x-pbx-authentication'] = `${key_id}:${key}`;
            return config;
        });
        this.axios.interceptors.response.use(async (response) => {
            if (!response.data.isNotAuth)
                return response;
            await this.authorize();
            return this.axios.request(response.config); // restart request
        });
        this.axios.interceptors.response.use(async (response) => {
            if (response.status !== 429)
                return response; // too many request error
            await new Promise(resolve => setTimeout(resolve, 1000)); // limit is 5 per second, so we have to wait for 1 second
            return this.axios.request(response.config); // restart request
        });
        if (!this.getCredentials().key || !this.getCredentials().key_id)
            this.authorizePromise = this.authorize();
    }
    async createPhoneCall(phone) {
        if (this.authorizePromise) {
            await this.authorizePromise;
            this.authorizePromise = undefined;
        }
        const formData = new URLSearchParams();
        formData.append('to', this.preparePhoneNumber(phone));
        formData.append('from', '100');
        return await this.axios.postForm('call/now.json', formData).then((response) => response.data);
    }
    async fetchCallsHistory(phone, options) {
        if (this.authorizePromise) {
            await this.authorizePromise;
            this.authorizePromise = undefined;
        }
        const formData = new URLSearchParams();
        formData.append('sub_phone_numbers', [this.preparePhoneNumber(phone)].join(','));
        if (options.dateFilter) {
            formData.append('start_stamp_from', (options.dateFilter.start.getTime() / 1000).toString());
            formData.append('start_stamp_to', Math.trunc(options.dateFilter.end.getTime() / 1000).toString());
        }
        const calls = await this.axios.postForm('mongo_history/search.json', formData).then((response) => {
            const responseData = response.data;
            if (responseData.status)
                return responseData.data;
            else
                throw new Error(responseData);
        });
        if (!calls)
            return [];
        return calls.map((call) => {
            if (call.accountcode == 'inbound' && call.user_talk_time == 0)
                call.accountcode = 'missed';
            return call;
        });
    }
    /**
     * Authorization method. It saves credentials to localStorage
     *
     * @param params  - array where [0] - key_id and [1] - key
     */
    async authorize(params = []) {
        const formData = new URLSearchParams();
        formData.append('auth_key', this.apiKey);
        formData.append('new', 'true');
        formData.append('key_id', params[0]);
        formData.append('key', params[1]);
        const response = await this.axios.post('auth.json', formData);
        if (response.data && response.data.status == 1)
            this.saveCredentials(response.data.data.key, response.data.data.key_id);
        return response.data && response.data.status > 0;
    }
    async getRecordUrl(uuid) {
        const formData = new URLSearchParams();
        formData.append('uuid', uuid);
        formData.append('download', '1');
        const callUrl = await this.axios.postForm('mongo_history/search.json', formData).then((response) => {
            const responseData = response.data;
            if (responseData.status)
                return responseData.data;
            else
                throw new Error(responseData);
        });
        if (typeof callUrl === 'string')
            return callUrl;
        else
            return null;
    }
    saveCredentials(key, key_id) {
        window.localStorage.setItem('onlinePBX_key', key);
        window.localStorage.setItem('onlinePBX_key_id', key_id);
    }
    getCredentials() {
        return {
            key: window.localStorage.getItem('onlinePBX_key'),
            key_id: window.localStorage.getItem('onlinePBX_key_id'),
        };
    }
    preparePhoneNumber(phone) {
        const phoneNumber = parsePhoneNumber(phone);
        if (!phoneNumber)
            return phone;
        return phone.replace(new RegExp('\\D', 'gm'), '').replace(phoneNumber.countryCallingCode, '');
    }
}
